import { ChangeDetectionStrategy, Component, input, OnInit, signal, Signal, WritableSignal } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { secure } from "@calaosoft/osapp-common/rxjs/operators/secure";
import { StringHelper } from "@calaosoft/osapp-common/utils/helpers/stringHelper";
import { combineLatest, map, Observable, of, switchMap, tap } from "rxjs";
import { DmsFile } from "../../../dms/model/DmsFile";
import { IDmsData } from "../../../dms/model/IDmsData";
import { DmsService } from "../../../dms/services/dms.service";
import { DestroyableComponentBase } from "../../../utils/components/destroyable-component-base";

@Component({
	selector: "calao-document-image-preview",
	templateUrl: "./document-image-preview.component.html",
	styleUrls: ["./document-image-preview.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class DocumentImagePreviewComponent extends DestroyableComponentBase implements OnInit {
	//#region PROPERTIES

	/** Guid de l'image à afficher. */
	public readonly guid: Signal<string | undefined> = input();
	private readonly guid$: Observable<string | undefined> = toObservable(this.guid);

	/** Image à afficher si déjà récupérée. */
	public readonly file: Signal<DmsFile | undefined> = input();
	private readonly file$: Observable<DmsFile | undefined> = toObservable(this.file);

	/** Image à afficher. */
	public image: WritableSignal<DmsFile | undefined> = signal<DmsFile | undefined>(undefined);

	//#endregion PROPERTIES

	constructor(private readonly isvcDms: DmsService) {
		super();
	}

	public ngOnInit(): void {
		combineLatest([this.guid$, this.file$])
			.pipe(
				switchMap(([psGuid, poFile]: [string | undefined, DmsFile | undefined]) => {
					if (!StringHelper.isBlank(psGuid))
						return this.isvcDms.get(psGuid).pipe(map((poDmsData: IDmsData) => poDmsData.file));
					return of(poFile);
				}),
				tap((poImage: DmsFile | undefined) => this.image.set(poImage)),
				secure(this)
			)
			.subscribe();
	}

	public onError(): void {
		this.image.set(undefined);
	}
}
